export enum AppRecordEditMode {
  UPDATE_RELEASE = 'updateRelease',
  UPDATE_ENTRY = 'updateEntry',
  UPDATE_EXAM_INFO = 'updateExamInfo',
}
